import type { Dispatch } from 'react';
import type { Reducer } from 'redux';

import type { SubmitStatus } from 'src/hooks/submit';
import { calculateProfit } from 'src/utils/priceGuide';

export const submitFinanceDetails =
  (
    setFormStatus: (s: SubmitStatus) => void,
    financesDetails: FinancesDetails,
  ) =>
  (dispatch: Dispatch<Action>) => {
    setFormStatus({ status: 'LOADING' });
    dispatch({
      type: 'FINANCES_SUBMITTED',
      payload: financesDetails,
    });
    setFormStatus({ status: 'SUCCESS' });
  };

export const submitOperationsDetails =
  (
    setFormStatus: (s: SubmitStatus) => void,
    operationsDetails: OperationsDetails,
  ) =>
  (dispatch: Dispatch<Action>) => {
    setFormStatus({ status: 'LOADING' });
    dispatch({
      type: 'OPERATIONS_SUBMITTED',
      payload: operationsDetails,
    });
    setFormStatus({ status: 'SUCCESS' });
  };

interface State {
  industry?: string;
  rent?: number;
  stock?: number;
  expenses?: number;
  profit?: number;
  staff?: number;
  revenue?: number;
  working?: string;
  procedures?: string;
  experience?: string;
}

const initialState: State = {
  industry: undefined,
  rent: undefined,
  stock: undefined,
  expenses: undefined,
  profit: undefined,
  staff: undefined,
  revenue: undefined,
  working: undefined,
  procedures: undefined,
  experience: undefined,
};

const reducer: Reducer<State, Action> = (
  state = initialState,
  action: Action,
) => {
  switch (action.type) {
    case 'FINANCES_SUBMITTED':
      const { revenue, rent, expenses } = action.payload;
      const profit = calculateProfit(revenue, rent, expenses);
      return {
        ...state,
        ...action.payload,
        profit,
      };
    case 'OPERATIONS_SUBMITTED':
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default reducer;

export interface FinancesDetails {
  revenue: number;
  rent: number;
  expenses: number;
  stock: number;
  industry: string;
}

export interface OperationsDetails {
  staff: number;
  working: string;
  procedures: string;
  experience: string;
}

export type BusinessValueData = FinancesDetails &
  OperationsDetails & { profit: number };

export type Action =
  | {
      type: 'FINANCES_SUBMITTED';
      payload: FinancesDetails;
    }
  | {
      type: 'OPERATIONS_SUBMITTED';
      payload: OperationsDetails;
    };
